var _desc, _g;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPullDown = function SvgPullDown(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6px",
    height: "4px",
    viewBox: "0 0 6 4",
    ref: svgRef
  }, props), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5DE5\\u4F5C\\u53F0/\\u89D2\\u8272\\u7BA1\\u7406/\\u5B50\\u8D26\\u53F7",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4E3B\\u8D26\\u53F7-\\u5DE5\\u4F5C\\u53F001",
    transform: "translate(-1419.000000, -24.000000)",
    fill: "#959595"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-74",
    transform: "translate(1419.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\u77E9\\u5F62",
    points: "0 0 6 0 3 4"
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPullDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pullDown.838f3eef.svg";
export { ForwardRef as ReactComponent };